"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  getInteractionModality: function getInteractionModality() {
    return _getInteractionModality;
  },
  setInteractionModality: function setInteractionModality() {
    return _setInteractionModality;
  },
  trackFocusVisible: function trackFocusVisible() {
    return _trackFocusVisible;
  },
  trackInteractionModality: function trackInteractionModality() {
    return _trackInteractionModality;
  }
});

module.exports = __toCommonJS(src_exports);

var import_dom_query = require("@zag-js/dom-query");

var hasSetup = false;
var modality = null;
var hasEventBeforeFocus = false;
var hasBlurredWindowRecently = false;
var handlers = /* @__PURE__ */new Set();

function trigger(modality2, event) {
  handlers.forEach(function (handler) {
    return handler(modality2, event);
  });
}

var isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;

function isValidKey(e) {
  return !(e.metaKey || !isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}

function onKeyboardEvent(event) {
  hasEventBeforeFocus = true;

  if (isValidKey(event)) {
    modality = "keyboard";
    trigger("keyboard", event);
  }
}

function onPointerEvent(event) {
  modality = "pointer";

  if (event.type === "mousedown" || event.type === "pointerdown") {
    hasEventBeforeFocus = true;
    var target = event.composedPath ? event.composedPath()[0] : event.target;
    var matches = false;

    try {
      matches = target.matches(":focus-visible");
    } catch (_unused) {}

    if (matches) return;
    trigger("pointer", event);
  }
}

function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  return event.detail === 0 && !event.pointerType;
}

function onClickEvent(e) {
  if (isVirtualClick(e)) {
    hasEventBeforeFocus = true;
    modality = "virtual";
  }
}

function onWindowFocus(event) {
  if (event.target === window || event.target === document) {
    return;
  }

  if (!hasEventBeforeFocus && !hasBlurredWindowRecently) {
    modality = "virtual";
    trigger("virtual", event);
  }

  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = false;
}

function onWindowBlur() {
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = true;
}

function isFocusVisible() {
  return modality !== "pointer";
}

function setupGlobalFocusEvents() {
  if (!(0, import_dom_query.isDom)() || hasSetup) {
    return;
  }

  var focus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function focusElement() {
    hasEventBeforeFocus = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    focus.apply(this, args);
  };

  document.addEventListener("keydown", onKeyboardEvent, true);
  document.addEventListener("keyup", onKeyboardEvent, true);
  document.addEventListener("click", onClickEvent, true);
  window.addEventListener("focus", onWindowFocus, true);
  window.addEventListener("blur", onWindowBlur, false);

  if (typeof PointerEvent !== "undefined") {
    document.addEventListener("pointerdown", onPointerEvent, true);
    document.addEventListener("pointermove", onPointerEvent, true);
    document.addEventListener("pointerup", onPointerEvent, true);
  } else {
    document.addEventListener("mousedown", onPointerEvent, true);
    document.addEventListener("mousemove", onPointerEvent, true);
    document.addEventListener("mouseup", onPointerEvent, true);
  }

  hasSetup = true;
}

function _trackFocusVisible(fn) {
  setupGlobalFocusEvents();
  fn(isFocusVisible());

  var handler = function handler() {
    return fn(isFocusVisible());
  };

  handlers.add(handler);
  return function () {
    handlers.delete(handler);
  };
}

function _trackInteractionModality(fn) {
  setupGlobalFocusEvents();
  fn(modality);

  var handler = function handler() {
    return fn(modality);
  };

  handlers.add(handler);
  return function () {
    handlers.delete(handler);
  };
}

function _setInteractionModality(value) {
  modality = value;
  trigger(value, null);
}

function _getInteractionModality() {
  return modality;
} // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  getInteractionModality: _getInteractionModality,
  setInteractionModality: _setInteractionModality,
  trackFocusVisible: _trackFocusVisible,
  trackInteractionModality: _trackInteractionModality
});